export const validateCuil = (cuil: string) => {
  if (cuil) {
    cuil = cuil.toString().replace(/-/g, '');

    let sum = 0;
    const cuilDigits = cuil.split('');
    const weightFactors = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

    if (cuil && cuil.length === 11) {
      for (let i = 0; i <= 9; i++) {
        sum += Number(cuilDigits[i]) * weightFactors[i];
      }

      sum = 11 - (sum % 11);

      if ((sum === 11 ? 0 : sum === 10 ? 9 : sum) === Number(cuilDigits[10]))
        return true;

      return false;
    }

    return false;
  }

  return false;
};
